export class PendingApprovalError extends Error {
  constructor() {
    super('Failed to login. Pending admin approval')
    this.name = 'PendingApprovalError'
  }
}
